/*
 * @Author: Tong.yu
 * @Date: 2022-12-16 13:13:47
 * @LastEditTime: 2022-12-20 10:11:37
 * @LastEditors: tong.yu1@simceredx.com
 * @Description: 
 * @FilePath: \git\simsysconfig\ssologin\src\layouts\UserLayout.jsx
 * 可以输入预定的版权声明、个性签名、空行等
 */
import React from 'react';
import './userLayout.scss';

const UserLayout = props => {
  const {
    children
  } = props;
  return (
      <div className='login-wrapper'>
        <div className="container">
          <div className='l-part'>
            {/* <img src={utils.imgList.loginTit} alt="图标" className="l-icon"/> */}
            <span className='l-info'>用精准医疗帮助每个人</span>
          </div>
          <div className="content">
            {/* <div className="right"> */}
              {children}              
            {/* </div> */}
          </div>
        </div>
        {/* 版权 */}
        <div className="footer">
          © Copyright 2021 江苏先声医学诊断有限公司 版权所有 All Rights Reserved.
        </div>
      </div>
  );
};

export default UserLayout;
